import {Coach} from "../../src/interfaces/interfaces";
import {TrenerskaTrida} from "../../src/interfaces/enums";

const judgesESG : Coach[] = [
    {
        level: TrenerskaTrida.trida1,
        name: 'Kapounková Kateřina',
    },
    {
        level: TrenerskaTrida.trida1,
        name: 'Surková Iva',
    },
    {
        level: TrenerskaTrida.trida2,
        name: 'Urbancová Markéta',
    },
]

export default judgesESG